var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleShare = function SvgGoogleShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.442 13.184c5.174-3.012 13.477 4.487 19.8 2.764 6.323-1.723 10.554-.441 14.494 6.44 3.211 5.607-2.095 5.526 2.805 17.824 4.9 12.3-3.46 13.09-11.539 13.09-9.834.375-14.648.696-21.278.696-6.629 0-9.76.304-13.523-6.268C3.046 42.22-4.251 36.783 3.332 30.216c7.583-6.568 5.57-13.225 12.11-17.032Z",
    fill: "#F0F5FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-share_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.333 20.735c0-1.668-.138-2.885-.438-4.147H27.406v7.527h11.44c-.23 1.871-1.476 4.688-4.244 6.581l-.039.252 6.162 4.665.427.042c3.92-3.539 6.181-8.745 6.181-14.92Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.407 40.568c5.605 0 10.31-1.803 13.746-4.913l-6.55-4.959c-1.753 1.195-4.105 2.029-7.196 2.029a12.47 12.47 0 0 1-11.808-8.43l-.244.021-6.407 4.846-.084.227c3.414 6.626 10.425 11.18 18.543 11.18Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.595 24.296a12.23 12.23 0 0 1-.692-4.012c0-1.397.254-2.75.669-4.012l-.012-.268-6.487-4.924-.212.099a19.927 19.927 0 0 0-2.215 9.105c0 3.268.808 6.356 2.215 9.105l6.734-5.093Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.407 7.843c3.898 0 6.527 1.645 8.027 3.02l5.858-5.59C37.694 2.007 33.012 0 27.407 0 19.29 0 12.277 4.553 8.864 11.179l6.712 5.093c1.683-4.89 6.342-8.429 11.831-8.429Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google-share_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(6.646)",
    d: "M0 0h40.708v40.708H0z"
  })))));
};
export default SvgGoogleShare;